import { Bar } from 'react-chartjs-2'
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js'
import type { Submission } from '../../lib/types'
import { C } from '../../lib/colors'

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend)

const BASE = { responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false } } }
const GRID_COLOR = 'rgba(1,87,98,0.07)'
const TIER_LABELS = ['Attuned', 'Listening In', 'Urgent Conv.', 'Priority Review']

interface Props { data: Submission[] }

export function Timeline({ data }: Props) {
  // Group by ISO week
  const weekMap = new Map<string, number[]>()
  data.forEach(d => {
    const date = new Date(d.created_at)
    const day  = date.getDay()
    const diff = date.getDate() - day + (day === 0 ? -6 : 1)
    const monday = new Date(date.setDate(diff))
    const key = monday.toISOString().split('T')[0]
    if (!weekMap.has(key)) weekMap.set(key, [0, 0, 0, 0])
    weekMap.get(key)![d.tier - 1]++
  })
  const weeks = Array.from(weekMap.entries()).sort((a, b) => a[0].localeCompare(b[0]))
  const weekLabels = weeks.map(([k]) => k)

  const datasets = [1, 2, 3, 4].map((t, i) => ({
    label: `Tier ${t} · ${TIER_LABELS[i]}`,
    data: weeks.map(([, counts]) => counts[i]),
    backgroundColor: C.tier[i],
    borderRadius: 3,
  }))

  return (
    <section className="sec" id="timeline">
      <div className="sec-hd">
        <div className="sec-label">09 · Temporal Trend</div>
        <h2 className="sec-title">How are submissions distributed over time?</h2>
        <p className="sec-sub">Volume by week, coloured by tier composition.</p>
      </div>
      <div className="card">
        <div className="card-title">Weekly submissions — by tier</div>
        <div className="card-sub">Stacked by tier. Week beginning date shown.</div>
        <div className="tier-legend">
          {C.tier.map((col, i) => (
            <div key={i} className="tl-item">
              <div className="tl-sw" style={{ background: col }} />
              Tier {i + 1} · {TIER_LABELS[i]}
            </div>
          ))}
        </div>
        <div className="cw h240">
          <Bar
            data={{ labels: weekLabels, datasets }}
            options={{
              ...BASE,
              scales: { x: { stacked: true, grid: { display: false } }, y: { stacked: true, grid: { color: GRID_COLOR } } },
              plugins: { legend: { display: true, position: 'bottom' as const, labels: { boxWidth: 10, padding: 8, font: { size: 10 } } } },
            }}
          />
        </div>
      </div>
    </section>
  )
}
